import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Divider, TableBody, TableCell, TableHead, Checkbox, TableSortLabel, TableRow, Table, TableContainer, TablePagination } from '@mui/material';
import { Button } from '@material-ui/core';
import { useEffect, useState, useReducer, useContext } from 'react';
import { i18n } from '../../../translate/i18n';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import toastError from '../../../errors/toastError';
import api from '../../../services/api';
import { AuthContext } from '../../../context/Auth/AuthContext';
import socket from '../../../hooks/useSocket';
import ImportWhatsappMessageStoreModal from './storeModal';
import FormatDate from '../../../helpers/FormatDate';
import ConfirmationModal from '../../ConfirmationModal';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@material-ui/icons/PlayCircleFilledWhiteOutlined';
import CircularProgressWithLabel from '../../General/CircularProgressWithLabel';

const Transition = React.forwardRef(function Transition(
    props,
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    button: {
        padding: "7px",
        float: "right",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        "& svg": {
            color: theme.palette.primary.contrastText,
            marginRight: '5px'
        },
    },
    actionButton: {
        background: "#eeeeee",
        width: "35px",
        minWidth: "35px",
        marginLeft: "5px",
        "&:hover": {
            background: "#bdbdbd"
        }
    }
}));

const reducer = (state, action) => {
    if (action.type == "LOAD_REGISTERS") {
        const registers = action.payload;
        return !registers ? [] : registers;
    }

    if (action.type == "UPDATE_REGISTERS") {
        let { register } = action.payload;
        if (!register) register = action.payload;
        if (!register) return;

        if (!Array.isArray(state) || state.length == 0) return [register];
        const registerIndex = state.findIndex((r) => r.id == register.id);

        if (registerIndex != -1) {
            state[registerIndex] = register;
            return [...state];
        } else {
            return [register, ...state];
        }
    }

    if (action.type == "DELETE_REGISTER") {
        const registerId = action.payload;

        const registerIndex = state.findIndex((r) => r.id == registerId);
        if (registerIndex != -1) {
            state.splice(registerIndex, 1);
        }
        return [...state];
    }

    if (action.type === "RESET") {
        return [];
    }
};

const ImportWhatsappMessageTableModal = ({ open, onClose, id }) => {

    const classes = useStyles();
    const fullWidth = true;
    const maxWidth = 'md';
    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [registers, dispatch] = useReducer(reducer, []);
    const [total, setTotal] = useState(0);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("createdAt");
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [page, setPage] = useState(0);
    const [storeModal, setStoreModal] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);
    const confirmationModalInitialState = {
		action: "",
		title: "",
		message: "",
		whatsAppId: "",
		open: false,
	};
    const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);

    useEffect(() => {

        if (open != true || !id) return;

        const importMessageHistoryEventName = `whatsappMessageImport-${user.adminId}`;
        const importMessageHistoryEventFunction = async (data) => {
            if (data.action === "update" || data.action === "create") {
                if (data?.register?.connectionId == id) {
                    dispatch({ type: "UPDATE_REGISTERS", payload: data.register });
                }
            }
            if (data.action === "delete") {
                dispatch({ type: "DELETE_REGISTER", payload: +data.registerId });
            }
        };

        socket.on(importMessageHistoryEventName, importMessageHistoryEventFunction);

        return () => {
            socket.off(importMessageHistoryEventName, importMessageHistoryEventFunction);
        };
    }, [open, id]);

    useEffect(() => {
        if (open != true || !id) return;

        (async () => {
            try {
                const { data } = await api.get(`/whatsapp/importMessageHistory/list/${id}`, {
                    params: {
                        page: page + 1,
                        limit: rowsPerPage,
                        orderBy,
                        order,
                    },
                });

                dispatch({ type: "LOAD_REGISTERS", payload: data.registers }); // Verifique se o payload é o esperado
                setTotal(data.total);
            } catch (err) {
                console.error(err);
                toastError(err);
            } finally {
                setLoading(false);
            }
        })();

    }, [open, page, rowsPerPage, order, orderBy]);

    const columns = [
        { 
            id: "createdAt",
            label: i18n.t("connections.whatsapp.importMessages.createdAt"),
            sortable: true
        },
        { 
            id: "status",
            label: i18n.t("connections.whatsapp.importMessages.status.title"),
            sortable: true
        },
        // {
        //     id: "startDate",
        //     label: i18n.t("connections.whatsapp.importMessages.startDate"),
        //     sortable: true
        // },
        // {
        //     id: "endDate",
        //     label: i18n.t("connections.whatsapp.importMessages.endDate"),
        //     sortable: true
        // },
        {
            id: "queue",
            label: i18n.t("connections.whatsapp.importMessages.queue"),
            sortable: false
        },
        {
            id: "progress",
            label: i18n.t("connections.whatsapp.importMessages.progress"),
            sortable: false
        },
        {
            id: "actions",
            label: i18n.t("connections.whatsapp.importMessages.actions"),
            sortable: false,
            align: "center"
        },
    ];

    // função para ordenar a tabela, de acordo com a ordenação selecionada
    const sortTable = (array, comparator) => {
        return array.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
    }

    const getComparator = (order, orderBy) => {

        const descendingComparator = (a, b, orderBy) => {
            if (!a || !b) return 0;
            if (!(orderBy in a) || !(orderBy in b)) return 0;
            return (b[orderBy] < a[orderBy]) ? -1 : (b[orderBy] > a[orderBy]) ? 1 : 0;
        };

        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleClose = (event, reason) => {

        if (reason == 'backdropClick') {
            event.preventDefault();
            return;
        }

        setLoading(false);
        dispatch('RESET');
        setTotal(0);
        setOrder("asc");
        setOrderBy("createdAt");
        setRowsPerPage(20);
        setPage(0);
        setStoreModal(false);
        setSelectedEdit(null);
        onClose();
    }

    const handleModalClose = () => {
        setStoreModal(false);
        if (selectedEdit != null) setSelectedEdit(null);
    }

    const handleModalOpen = () => {
        setStoreModal(true);
    }

    const handleEditModal = (register) => {
        setStoreModal(true);
        setSelectedEdit(register);
    }

    const handleOpenConfirmationModal = (action, id) => {
        if (action == 'delete') {
            setConfirmModalInfo({
                action: "delete",
                title: i18n.t("connections.whatsapp.importMessages.deleteTitle"),
                message: i18n.t("connections.whatsapp.importMessages.deleteMessage"),
                id: id,
                open: true
            });
        }
        if (action == 'start') {
            setConfirmModalInfo({
                action: "start",
                title: i18n.t("connections.whatsapp.importMessages.startTitle"),
                message: i18n.t("connections.whatsapp.importMessages.startMessage"),
                id: id,
                open: true
            });
        }
    };

    const handleSubmitConfirmationModal = async () => {
        if (confirmModalInfo.action == 'delete') {
            try {
                await api.delete(`/whatsapp/importMessageHistory/delete/${confirmModalInfo.id}`);
                toast.success(i18n.t("connections.whatsapp.importMessages.deletedSuccesfully"));
            } catch (err) {
                console.error({ err });
                return;
                toastError(err);
            }
        }
        if (confirmModalInfo.action == 'start') {
            await handleStart(confirmModalInfo.id);
            setTimeout(() => {
                handleClose();
            }, 500);
        }
        setConfirmModalInfo(confirmationModalInitialState);
    };

    const handleStart = async (id) => {
        try {
            await api.post(`/whatsapp/importMessageHistory/start`, { id });
            toast.success(i18n.t("connections.whatsapp.importMessages.startedSuccesfully"));
        } catch (err) {
            console.error({ err });
            toastError(err);
        }
    };

    const handleChangePage = (event, newPage) => {
        // Verifica se a nova página está dentro dos limites
        if (newPage < 0) {
            setPage(0);
        } else if (newPage >= total) {
            setPage(total - 1);
        } else {
            setPage(newPage);
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Dialog
                open={open == true ? true : false}
                TransitionComponent={Transition}
                keepMounted
                onClose={(event, reason) => handleClose(event, reason)}
                aria-describedby="alert-dialog-slide-template"
                disableEscapeKeyDown={true}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
                <DialogTitle>
                    {i18n.t("connections.whatsapp.importMessages.title")}
                    <Button
                        size="small"
                        variant="contained"
                        className={classes.button}
                        onClick={handleModalOpen}
                        disabled={Array.isArray(registers) && registers.findIndex(r => r.status == 'starting') != -1}
                    >
                        {i18n.t("connections.whatsapp.importMessages.buttons.add")}
                    </Button>
                    <Divider sx={{ marginTop: "10px" }} />
                </DialogTitle>
                <DialogContent>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columns.map((col, index) => {
                                        const isSortable = col.sortable != false;
                                        return (
                                            <TableCell
                                                key={`${index}-importWhatsappMessage-${id}`}
                                                align={col?.align ? col.align : "left"}
                                                sortDirection={isSortable && orderBy === col.id ? order : false}
                                            >
                                                {isSortable ? (
                                                    <TableSortLabel
                                                        active={orderBy === col.id}
                                                        direction={orderBy === col.id ? order : "asc"}
                                                        onClick={createSortHandler(col.id)}
                                                    >
                                                        {col.label}
                                                    </TableSortLabel>
                                                ) : (
                                                    col.label
                                                )}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    Array.isArray(registers) && registers.length > 0 ?
                                        sortTable(registers, getComparator(order, orderBy)).map(r => {
                                            return (
                                                <TableRow>
                                                    <TableCell>{FormatDate(r.createdAt, false)}</TableCell>
                                                    <TableCell>{i18n.t(`connections.whatsapp.importMessages.status.${r.status}`)}</TableCell>
                                                    {/* <TableCell>{FormatDate(r.startDate, false)}</TableCell>
                                                    <TableCell>{FormatDate(r.endDate, false)}</TableCell> */}
                                                    <TableCell>{r?.Queue?.name || '-'}</TableCell>
                                                    <TableCell>
                                                        <CircularProgressWithLabel
                                                            value={r?.totalMessages > 0 && r?.totalMessagesProcessed > 0 ? ((r.totalMessagesProcessed / r.totalMessages) * 100).toFixed(0) : '0'}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            title={i18n.t("buttons.delete")}
                                                            size="small"
                                                            className={classes.actionButton}
                                                            disabled={r?.status != 'pending' ? true : false}
                                                            onClick={e => {
                                                                handleOpenConfirmationModal('delete', r.id);
                                                            }}
                                                        >
                                                            <DeleteOutlineOutlinedIcon />
                                                        </Button>
                                                        <Button
                                                            title={i18n.t("buttons.edit")}
                                                            size="small"
                                                            className={classes.actionButton}
                                                            disabled={r?.status != 'pending' ? true : false}
                                                            onClick={() => { handleEditModal(r) }}
                                                        >
                                                            <EditOutlinedIcon />
                                                        </Button>
                                                        <Button
                                                            title={i18n.t("buttons.start")}
                                                            size="small"
                                                            className={classes.actionButton}
                                                            disabled={r?.status != 'pending' ? true : false}
                                                            onClick={e => {
                                                                handleOpenConfirmationModal('start', r.id);
                                                            }}
                                                        >
                                                            <PlayCircleFilledWhiteOutlinedIcon />
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        :
                                        <TableRow>
                                            <TableCell
                                                colSpan={columns.length + 1}
                                                align="center"
                                            >
                                                {i18n.t("connections.whatsapp.importMessages.notFound")}
                                            </TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[20, 50, 100]}
                        component="div"
                        count={total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        labelRowsPerPage={i18n.t("connections.whatsapp.importMessages.resultPerPage")}
                        labelDisplayedRows={({ from, to, count }) => `${i18n.t("connections.whatsapp.importMessages.total")} ${count} / ${i18n.t("connections.whatsapp.importMessages.from")} ${from} ${i18n.t("connections.whatsapp.importMessages.to")} ${to}`}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                                marginTop: "10px"
                            },
                        }}
                    />

                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            handleClose();
                        }}
                        variant="outlined"
                        color="error"
                        disabled={loading}
                    >
                        {i18n.t("connections.whatsapp.importMessages.buttons.close")}
                    </Button>
                </DialogActions>
            </Dialog>
            <ImportWhatsappMessageStoreModal 
                open={storeModal == true ? true : false}
                onClose={handleModalClose}
                id={selectedEdit?.id || undefined}
                connectionId={id}
            />
            <ConfirmationModal
                title={confirmModalInfo.title}
                open={confirmModalInfo?.open == true ? true : false}
                onClose={() => {
                    setConfirmModalInfo(confirmationModalInitialState);
                }}
                onConfirm={handleSubmitConfirmationModal}
            >
                {confirmModalInfo.message}
            </ConfirmationModal>
        </>
    );
}

export default ImportWhatsappMessageTableModal;